/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ValidationErrors } from '@angular/forms';
import { Formula, substituteFormulaParams } from '@gh/builder-shared-data';
import { isNil } from 'lodash';
import { FormulaContext } from './formula-context';

export function formulaControlValidator({ value }: { value: Maybe<Formula> }): ValidationErrors | null {
  return formulaValidator(value);
}

export function formulaValidator(formula: Maybe<Formula>): ValidationErrors | null {
  return (isNil(formula) || formula.valid) ? null : { formula: true }; // tslint:disable-line:no-null-keyword
}

export function getReadableFormulaExpression(context: FormulaContext, formula?: Formula): string {
  return substituteFormulaParams(formula && formula.expression || '', (topId) => {
    const variable = context.variables[topId];

    return variable && variable.name || topId;
  });
}
